module.exports = __webpack_public_path__ + "img/McAfee-MVISION-EDR.97fc2e7.svg";